import { LOCAL_STORAGE } from '../constants/local-storage';
import { initialState } from '../redux/modules/app';
import { setItemWithExpiry } from './local-storage-with-expiry';

export const getParamsDeepLinkUrl = (url: string, appVersion: string) => {
  const urlParams = new URLSearchParams(url.split('?')[1]);

  const { versionGplayReview } = initialState;

  const setUtmLocalStorage = (utm: string, localStorageValue: string) => {
    if (urlParams.has(utm)) {
      const utmValue = urlParams.get(utm);

      if (utmValue) setItemWithExpiry(localStorageValue, utmValue);
    }

    if (!urlParams.has(utm) && urlParams.entries().next().done === false) {
      localStorage.removeItem(localStorageValue);
    }
  };

  if (urlParams.has('landing_devFingerprint')) {
    const fingerprint = urlParams.get('landing_devFingerprint');

    if (fingerprint && !localStorage.getItem(LOCAL_STORAGE.xLandingFingerprint)) {
      localStorage.setItem(LOCAL_STORAGE.xLandingFingerprint, fingerprint);
    }
  }

  if (urlParams.has('utm_content')) {
    const utmContent = urlParams.get('utm_content');

    if (utmContent) {
      if (!versionGplayReview.includes(appVersion)) {
        localStorage.setItem(LOCAL_STORAGE.refCode, utmContent);
      }
      setItemWithExpiry(LOCAL_STORAGE.utm_content, utmContent);
    }
  }
  if (urlParams.has('utm_campaign')) {
    const utmCampaign = urlParams.get('utm_campaign');

    if (utmCampaign) {
      if (
        !versionGplayReview.includes(appVersion) &&
        (!urlParams.has('utm_content') ||
          (urlParams.has('utm_content') && urlParams.get('utm_content') === ''))
      ) {
        localStorage.setItem(LOCAL_STORAGE.refCode, utmCampaign);
      }
      setItemWithExpiry(LOCAL_STORAGE.utm_campaign, utmCampaign);
    }
  }

  setUtmLocalStorage('utm_medium', LOCAL_STORAGE.utm_medium);
  setUtmLocalStorage('utm_term', LOCAL_STORAGE.utm_term);
  setUtmLocalStorage('gclid', LOCAL_STORAGE.gclid);
  setUtmLocalStorage('fbclid', LOCAL_STORAGE.fbclid);
  setUtmLocalStorage('ttclid', LOCAL_STORAGE.ttclid);
  setUtmLocalStorage('utm_source', LOCAL_STORAGE.utm_source);

  if (urlParams.has('landing_gaid')) {
    const gaid = urlParams.get('landing_gaid');

    if (gaid && !localStorage.getItem(LOCAL_STORAGE.landingGaid)) {
      localStorage.setItem(LOCAL_STORAGE.landingGaid, gaid);
    }
  }
};
